import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { actions } from "../../../../Redux";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../../Components/MultiRangeSlider";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router-dom";

const Vouchers = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const financeVouchersList = useSelector(
    (state) => state?.financeReducer?.financeVouchersList
  );

  useEffect(() => {
    dispatch(actions?.getFinanceVouchersList());
  }, []);
  console.log(financeVouchersList, "financeVouchersList");

  function getStatusClass(status) {
    if (status === "Active") return "green_tag";
    if (status === "Redeemed" || status === "Expired") return "bordered_tag";
  }
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="top-header-sec mb-1">
                  <div className="col-12 mt-3">
                    <h4 className="event-alert br-btm-0">
                      Voucher List
                      <div className="clear"></div>
                    </h4>
                    <div className="row justify-content-between align-items-center">
                      <div className="col-md-4">
                        <div className="search-box mt-0">
                          <form type="GET">
                            <input
                              type="text"
                              placeholder="Search"
                              name="keyword1"
                            />
                            <input type="submit" />
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="shadowclass">
                <div class="col-12">
                  <div class="counts">
                    <h4 class="event-alert">Voucher List </h4>

                    <div className="shadowclass mt-0 p-0">
                      <div className="table-responsive">
                        <table className="checklist-table remove-space inventory_table">
                          <thead>
                            <tr>
                              <th>ID</th>
                              <th className="col-2">Voucher Name</th>
                              <th>Status</th>
                              <th class="col-2">Total Value</th>
                              <th class="col-2">Total Redeemed</th>
                              <th class="col-2">Total Unredeemed</th>
                              <th class="col-2">Expiry Date</th>
                              <th class="col-2"> Actions </th>
                            </tr>
                          </thead>
                          <tbody>
                            {financeVouchersList?.voucher_list?.map(
                              (el, idx) => (
                                <tr class="order_row">
                                  <td> {idx + 1}</td>
                                  <td>
                                    <b>{el?.method_name}</b> <br />
                                    {el?.voucher_group?.name}|{" "}
                                    {el?.ap_voucher_type_id}
                                  </td>
                                  <td>
                                    {" "}
                                    <span class={getStatusClass(el?.status)}>
                                      {el?.status}
                                    </span>
                                  </td>
                                  <td>
                                    {" "}
                                    {financeVouchersList?.currency}{" "}
                                    {el?.voucher_total_value}
                                  </td>
                                  <td>
                                    {" "}
                                    {financeVouchersList?.currency}{" "}
                                    {el?.total_redeemed}
                                  </td>
                                  <td>
                                    {financeVouchersList?.currency}{" "}
                                    {el?.voucher_total_value -
                                      el?.total_redeemed}
                                  </td>
                                  <td>{el?.final_date}</td>
                                  <td>
                                    <a
                                      class="circle_icon"
                                      onClick={() => {
                                        dispatch(
                                          actions?.getFinanceVouchers({
                                            payment_method_id: el?.id,
                                          })
                                        );
                                        history.push("/finance/vouchers");
                                      }}
                                    >
                                      <i class="iconSprites eye-icon"></i>
                                    </a>
                                    <div class="circle_icon">
                                      <a
                                        onClick={() => {
                                          dispatch(
                                            actions?.downloadFinanceVoucher({
                                              id: el?.id,
                                            })
                                          );
                                        }}
                                        class="iconSprites download-sm-icon"
                                      >
                                        {" "}
                                      </a>{" "}
                                    </div>
                                    <a
                                      class="circle_icon red"
                                      //   onClick={() => {
                                      //     dispatch(
                                      //       actions?.downloadFinanceVoucher({
                                      //         id: el?.id,
                                      //       })
                                      //     );
                                      //   }}
                                    >
                                      <i class="iconSprites cancel-icon"></i>
                                    </a>
                                  </td>
                                </tr>
                              )
                            )}

                            {/* <tr class="order_row">
                              <td> 2 </td>
                              <td>
                                <b>Harrys Voucher 2022</b> <br />
                                Harrys Vouchers | Standard Pre-Paid (Multi-Use){" "}
                              </td>
                              <td>
                                {" "}
                                <span class="bordered_tag"> Redeemed </span>
                              </td>
                              <td>$200.00</td>
                              <td>$200.00</td>
                              <td>$0.00 </td>
                              <td>31/12/2022</td>
                              <td>
                                <a
                                  class="circle_icon"
                                  href="/vouchers/index/735"
                                >
                                  <i class="iconSprites eye-icon"></i>
                                </a>
                                <div class="circle_icon">
                                  {" "}
                                  <a
                                    target="_blank"
                                    href="/vouchers/download_excel/735"
                                    class="iconSprites download-sm-icon"
                                  >
                                    {" "}
                                  </a>{" "}
                                </div>
                              </td>
                            </tr> */}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Vouchers;
